/*
 * PANTOZA product page extras: mobile gallery slider, bundle tiers, sale countdown,
 * sticky add-to-cart bar and autoplaying reels. Cart/variant logic lives in theme.js.
 */
(function () {
  if (window.PantozaProductPage) return;
  window.PantozaProductPage = true;

  var doc = document;
  function $(selector, scope) { return (scope || doc).querySelector(selector); }
  function $$(selector, scope) { return Array.prototype.slice.call((scope || doc).querySelectorAll(selector)); }

  function productData(section) {
    if (section._ppData) return section._ppData;
    var el = $('[data-product-json]', section);
    try { section._ppData = el ? JSON.parse(el.textContent) : null; } catch (e) { section._ppData = null; }
    return section._ppData;
  }

  function currentVariant(section) {
    var data = productData(section);
    var input = $('[data-variant-id]', section);
    if (!data || !input) return null;
    return data.variants.find(function (v) { return String(v.id) === input.value; }) || null;
  }

  /* Gallery: counter for the swipe slider */
  function initGallery(section) {
    var gallery = $('[data-gallery][data-layout="grid"]', section);
    if (!gallery) return;
    var track = $('[data-gallery-track]', gallery);
    var counter = $('[data-gallery-index]', gallery);
    if (!track || !counter) return;
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        counter.textContent = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) + 1;
        ticking = false;
      });
    }, { passive: true });
  }

  /* Bundle tiers set the quantity */
  function applyBundle(section) {
    var checked = $('[data-bundle] input:checked', section);
    var qty = $('[data-quantity-input]', section);
    if (checked && qty) qty.value = checked.getAttribute('data-bundle-qty');
  }

  function refreshVariantExtras(section) {
    var variant = currentVariant(section);
    if (!variant) return;
    $$('[data-save-pill]', section).forEach(function (pill) {
      pill.hidden = !variant.save;
      if (variant.save) pill.textContent = pill.textContent.replace(/\d+/, variant.save);
    });
    Object.keys(variant.tiers || {}).forEach(function (key) {
      var price = $('[data-tier-price="' + key + '"]', section);
      var compare = $('[data-tier-compare="' + key + '"]', section);
      if (price) price.innerHTML = variant.tiers[key].price;
      if (compare) compare.innerHTML = variant.tiers[key].compare;
    });
    var stickyPrice = $('[data-sticky-buy] [data-price]', section);
    if (stickyPrice) stickyPrice.innerHTML = variant.price;
    var stickyAdd = $('[data-sticky-add]', section);
    if (stickyAdd) stickyAdd.disabled = !variant.available;
  }

  /* Countdown to a real sale end time (India time) */
  function initCountdown(section) {
    $$('[data-countdown]', section).forEach(function (el) {
      var raw = el.getAttribute('data-countdown').trim().replace(' ', 'T');
      var end = Date.parse(raw.length <= 16 ? raw + ':00+05:30' : raw);
      var out = $('[data-countdown-value]', el);
      if (isNaN(end) || !out) return;
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
        out.textContent = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        el.hidden = false;
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* Sticky add-to-cart bar on mobile */
  function initSticky(section) {
    var bar = $('[data-sticky-buy]', section);
    var anchor = $('[data-main-buy]', section);
    if (!bar || !anchor) return;
    var ticking = false;
    function update() {
      ticking = false;
      // Show once the main buy buttons have scrolled above the viewport.
      bar.hidden = anchor.getBoundingClientRect().bottom > 0;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* Reels: play muted while visible */
  function initReels(scope) {
    var reels = $$('[data-reel]', scope);
    if (!reels.length) return;
    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = $('video', entry.target);
        if (!video || entry.target.dataset.userPaused === 'true') return;
        if (entry.isIntersecting) play(entry.target); else video.pause();
      });
    }, { threshold: 0.6 }) : null;

    reels.forEach(function (reel) {
      var video = $('video', reel);
      if (!video || reel.dataset.ready) return;
      reel.dataset.ready = 'true';
      video.muted = true;
      video.addEventListener('play', function () { syncButtons(reel); });
      video.addEventListener('pause', function () { syncButtons(reel); });
      if (observer && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) observer.observe(reel);
      syncButtons(reel);
    });
  }

  function play(reel) {
    var video = $('video', reel);
    if (!video) return;
    if (video.preload === 'none') video.preload = 'auto';
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  function syncButtons(reel) {
    var video = $('video', reel);
    var playBtn = $('[data-reel-play]', reel);
    var soundBtn = $('[data-reel-sound]', reel);
    if (!video) return;
    if (playBtn) {
      playBtn.setAttribute('aria-pressed', String(!video.paused));
      $('[data-icon-play]', playBtn).hidden = !video.paused;
      $('[data-icon-pause]', playBtn).hidden = video.paused;
    }
    if (soundBtn) {
      soundBtn.setAttribute('aria-pressed', String(!video.muted));
      $('[data-icon-muted]', soundBtn).hidden = !video.muted;
      $('[data-icon-sound]', soundBtn).hidden = video.muted;
    }
  }

  doc.addEventListener('click', function (event) {
    var playBtn = event.target.closest('[data-reel-play]');
    var soundBtn = event.target.closest('[data-reel-sound]');
    var reel = (playBtn || soundBtn) && (playBtn || soundBtn).closest('[data-reel]');
    if (!reel) return;
    var video = $('video', reel);
    if (playBtn) {
      if (video.paused) { reel.dataset.userPaused = 'false'; play(reel); }
      else { reel.dataset.userPaused = 'true'; video.pause(); }
    } else {
      video.muted = !video.muted;
      if (!video.muted) {
        $$('[data-reel] video').forEach(function (other) { if (other !== video) other.muted = true; });
        $$('[data-reel]').forEach(syncButtons);
        if (video.paused) play(reel);
      }
    }
    syncButtons(reel);
  });

  doc.addEventListener('change', function (event) {
    var target = event.target;
    var section = target.closest && target.closest('[data-product-section]');
    if (!section) return;
    if (target.closest('[data-bundle]')) applyBundle(section);
    if (target.matches('[data-option-input]')) setTimeout(function () { refreshVariantExtras(section); }, 0);
  });

  // Changing the quantity by hand clears a bundle choice that no longer matches.
  function syncBundleToQuantity(event) {
    if (!event.target.matches || !event.target.matches('[data-quantity-input]')) return;
    var section = event.target.closest('[data-product-section]');
    var bundle = section && $('[data-bundle]', section);
    if (!bundle) return;
    $$('input', bundle).forEach(function (input) {
      input.checked = input.getAttribute('data-bundle-qty') === event.target.value;
    });
  }
  doc.addEventListener('input', syncBundleToQuantity);
  doc.addEventListener('change', syncBundleToQuantity);

  function init(scope) {
    $$('[data-product-section]', scope).forEach(function (section) {
      if (section.dataset.ppReady) return;
      section.dataset.ppReady = 'true';
      initGallery(section);
      applyBundle(section);
      initCountdown(section);
      initSticky(section);
    });
    initReels(scope);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);
  doc.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
